import React from 'react'
import { useState, useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import '../Ranking/Ranking.css'
import { useTranslation } from "react-i18next";

const RankingDaily = () => {
  const { t } = useTranslation();
  
  const [rankingList, setRankingList] = useState([]);
  const [date, setDate] = useState(new Date());
  const [monthLabel, setMonthLabel] = useState('');
  const [prevMonthLabel, setPrevMonthLabel] = useState('');

  const [ranking, setRanking] = useState(0);
  const [prevRanking, setPrevRanking] = useState(0);
  const [totalRanking, setTotalRanking] = useState(0);

  const prevMonthButton = (e) => {
    setDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1));
  }

  const nextMonthButton = (e) => {
    setDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));
  }

  const [loadList, setLoadList] = useState(false)

  const getRanking = () => {
    setLoadList(true);
    setRanking('-');
    setPrevRanking('-');
    setTotalRanking('-');

    let currentDate = date;
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();

    // 2週間前の日付を取得
    let prevDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
    let prevYear = prevDate.getFullYear();
    let prevMonth = prevDate.getMonth() + 1;
    let prevDay = prevDate.getDate();

    setMonthLabel(`${year}${t('ranking.year')}${month}${t('ranking.month')}${day}${t('ranking_daily.day')}`);
    setPrevMonthLabel(`${prevYear}${t('ranking.year')}${prevMonth}${t('ranking.month')}${prevDay}${t('ranking_daily.day')}`);

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/ranking?year=${year}&month=${month}&day=${day}`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Content-Type': 'application/json'
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if(!data.errors) {
        setRanking(Number(data.month_total).toLocaleString('ja-JP'));
        setPrevRanking(Number(data.last_month_total).toLocaleString('ja-JP'));
        setTotalRanking(Number(data.total).toLocaleString('ja-JP'));
        setRankingList(data.package_sales);
        setLoadList(false)
      } else {
        alert(Object.values(data.errors)[0]);
      }
    })
    .catch(error => {
      alert(t('ranking.error'));
    });
  }
  
  useEffect(() => {
    setLoadList(true);
    setRanking('-');
    setPrevRanking('-');
    setTotalRanking('-');

    let currentDate = date;
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();

    // 2週間前の日付を取得
    let prevDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
    let prevYear = prevDate.getFullYear();
    let prevMonth = prevDate.getMonth() + 1;
    let prevDay = prevDate.getDate();

    setMonthLabel(`${year}${t('ranking.year')}${month}${t('ranking.month')}${day}${t('ranking_daily.day')}`);
    setPrevMonthLabel(`${prevYear}${t('ranking.year')}${prevMonth}${t('ranking.month')}${prevDay}${t('ranking_daily.day')}`);
    
    let timer = setTimeout(() => {
      getRanking();
    }, 500);
    return () => clearTimeout(timer);
  }, [date]);

  const CreateRankingList = () => {
    if (rankingList.length === 0) return (
      <tr>
        <td colSpan="7" className="ranking-content-table-loading">
          {t('ranking_daily.error')}
        </td>
      </tr>
    )

    return rankingList.map((ranking, index) => {
      ranking.ranking = index + 1;
      return (
        <Tr key={index} ranking={ranking} />
      )
    })
  }
    


  return (
    <>
      <Header />
      <SideMenu />
      <div className="ranking">
        <div className="ranking-title">{t('ranking.title')}</div>
        <div className='clearfix'></div>
        <div className="ranking-search">
          <div className="ranking-search-paging">
            <button className="ranking-search-paging-prev-button ranking-search-paging-button" onClick={prevMonthButton}>前へ</button>
            <div className="ranking-summary">
              <div className="ranking-summary-item-main">
                <div className="ranking-summary-item-main-title">{monthLabel}</div>
                <div className="ranking-summary-item-main-value">{ranking} {t('ranking.value')}</div>
              </div>
              <div className="ranking-summary-item-left">
              <div className="ranking-summary-item-left-title">{prevMonthLabel}</div>
                <div className="ranking-summary-item-left-value">{prevRanking} {t('ranking.value')}</div>
              </div>
              <div className="ranking-summary-item-right">
              <div className="ranking-summary-item-right-title">{t('ranking.total')}</div>
                <div className="ranking-summary-item-right-value">{totalRanking} {t('ranking.value')}</div>
              </div>
            </div>
            <button className="ranking-search-paging-next-button ranking-search-paging-button" onClick={nextMonthButton}>{t('ranking.next')}</button>
          </div>
        </div>
        <div className="ranking-content">
          <div className="ranking-content-table-title">
            {t('ranking.ranking')}
          </div>
          <div className="ranking-content-table">
            <table className="ranking-content-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{t('ranking.oripa')}</th>
                  <th>{t('ranking.total')}</th>
                  <th>{t('ranking.gacha1')}</th>
                  <th>{t('ranking.gacha2')}</th>
                  <th>{t('ranking.rest')}</th>
                  <th>{t('ranking_daily.user')}</th>
                </tr>
              </thead>
              <tbody>
                {!loadList ?
                  <CreateRankingList />
                  :
                  <>
                    <tr>
                      <td colSpan="7" className="ranking-content-table-loading">
                        {t('common.loading')}
                      </td>
                    </tr>
                  </>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default RankingDaily